export const DATE_COLUMNS = [
  // { label: '全部', value: '全部' },

  // { label: '9-12', value: '9-12' },
  // { label: '9-13', value: '9-13' },
  // { label: '9-14', value: '9-14' },
  // { label: '9-15', value: '9-15' },
  // { label: '9-16', value: '9-16' }

  { label: '9-10', value: '9-10' },
  { label: '9-11', value: '9-11' },
  { label: '9-12', value: '9-12' },
  { label: '9-13', value: '9-13' },
  { label: '9-14', value: '9-14' }
]
